export const GET_ALL_OPERADORES = 'GET_ALL_OPERADORES'
export const GET_SPECIFIC_OPERADOR = 'GET_SPECIFIC_OPERADOR'
export const GET_ALL_ROUTES = 'GET_ALL_ROUTES'
export const GET_ALL_QUEUES = 'GET_ALL_QUEUES'
export const GET_ALL_DEPARTAMENTOS = 'GET_ALL_DEPARTAMENTOS'
export const GET_OPERADORES_MONITOR = 'GET_OPERADORES_MONITOR'
export const LISTAR_GRUPOS_DE_ROTAS = 'LISTAR_GRUPOS_DE_ROTAS'